/**
 * Returns a safe file extension for an image MIME type.
 * Falls back to png when unknown.
 */
export function imageExtensionFromMimeType(mimeType: string | null | undefined): string {
    if (!mimeType) return 'png'

    const normalized = mimeType.toLowerCase().trim()
    const [baseMime] = normalized.split(';')

    if (baseMime === 'image/jpeg' || baseMime === 'image/jpg') return 'jpg'
    if (baseMime === 'image/svg+xml') return 'svg'

    const subtype = baseMime.split('/')[1]
    if (!subtype) return 'png'

    if (subtype === 'png' || subtype === 'gif' || subtype === 'webp' || subtype === 'bmp' || subtype === 'avif') {
        return subtype
    }

    return 'png'
}
